import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, CommonTypes } from 'st-common/App/CommonTypes';
import QuestionnaireAnsweredLookup from '../../Models/Questionnaires/Queries/QuestionnaireAnsweredLookup';

export interface IAnswerQuestionnaireQueryApiClient {

    /** 
     * Will get a preview of empty answers for the provided questionnaire.
     * @param questionnaireId The questionnaire id
     * @returns The approval summary
     */
    getPreviewQuestionnairesAnswered(questionnaireId: number): AxiosPromise<Model.PlainObject<QuestionnaireAnsweredLookup>>;

    /** 
     * Will get the question answers.
     * @param questionnaireAnsweredId The questionnaire answered id
     * @returns The approval summary
     */
    getQuestionnairesAnswered(questionnaireAnsweredId: number): AxiosPromise<Model.PlainObject<QuestionnaireAnsweredLookup>>;

    // Client only properties / methods
}

@injectable()
export default class AnswerQuestionnaireQueryApiClient extends Data.ApiClientBase implements IAnswerQuestionnaireQueryApiClient {

    constructor(config = AppService.get(CommonTypes.Config)) {
        super(`${config.AwardsApi.ApiPath}/questionnaire/answers`);
    }

    public getPreviewQuestionnairesAnswered(questionnaireId: number): AxiosPromise<Model.PlainObject<QuestionnaireAnsweredLookup>> {
        return this.axios.get(`${this.apiPath}/preview/${questionnaireId}`);
    }

    public getQuestionnairesAnswered(questionnaireAnsweredId: number): AxiosPromise<Model.PlainObject<QuestionnaireAnsweredLookup>> {
        return this.axios.get(`${this.apiPath}/${questionnaireAnsweredId}`);
    }

    // Client only properties / methods
}